import React from 'react';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import ShuffleIcon from '@mui/icons-material/Shuffle';

const PlaylistHeader = ({ playlist, isAdmin, onEdit, onDelete, onShuffle }) => {
	const handleEdit = e => {
		e.preventDefault();
		onEdit(playlist);
	};

	const handleDelete = e => {
		e.preventDefault();
		onDelete(playlist._id);
	};

	const handleShuffle = e => {
		e.preventDefault();
		onShuffle(playlist._id);
	};

	return (
		<div className="col-md-12 p-0">
			<div className="d-flex justify-content-between align-items-center gap-2 mb-2">
				<p className="playlist_name col mb-0">{playlist.name}</p>
				<div className="c-featured_box-left-b4 m-0 d-inline-flex align-items-center">
					<Link to="" onClick={handleShuffle} className="d-inline-flex outline__primary__btn shuffle">
						<span>
							<ShuffleIcon style={{ color: "#3cb4e4", fontSize: "1.5rem" }} />
						</span>
						<span className="d-none d-lg-flex align-self-center m-0">Shuffle</span>
					</Link>

					{isAdmin && (
						<Dropdown>
							<Dropdown.Toggle className="text-white p-1 drop__btn" id="dropdown-basic">
								<i className="fa-solid fa-ellipsis-vertical"></i>
							</Dropdown.Toggle>

							<Dropdown.Menu className="drop__menu">
								<button className="btn w-100 border-0" onClick={handleEdit}>
									Edit
								</button>
								<button className="btn w-100 border-0" onClick={handleDelete}>
									Delete
								</button>
							</Dropdown.Menu>
						</Dropdown>
					)}
				</div>
			</div>
		</div>
	);
};

export default PlaylistHeader;
